import { formatTimestamp } from "utils/date";
import { AppsTableData, AppsTableListItem } from "./Types";

export function getAppsTableData(data: AppsTableListItem[]): AppsTableData[] {

    if (!data) {
        return [];
    }

    return data.map((item) => {

        const timestamp = item?.status?.timestamp ? new Date(item?.status?.timestamp) : null;

        const lastModifiedDate = timestamp ? formatTimestamp(timestamp, "MM/dd/yy h:mm a")
            : "-"

        return {
            appId: item.appId,
            appIcon: item.smallIcon ?? "",
            appName: item.name,
            createdDate: "",
            lastModifiedDate,
            submitter: item?.status?.email ?? "-",
            status: item?.status?.type,
            notes: item?.status?.notes,
        };
    });
}
